// extracted by mini-css-extract-plugin
module.exports = {"navTrigger":"Close_navTrigger__qHdao","navTriggerOpen":"Close_navTriggerOpen__IrnEl"};